import React from 'react'
import styled from 'styled-components'


const Specer = styled.div`
    width:100%;
    height:15px;
    margin:0;
    padding:0;
`


const MiniSpecer = () =>{
    return(
        <Specer></Specer>
    )
}

export default MiniSpecer
